import { toast } from "@inno-ui/toast";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import type { SmartSchedulingSlotsPayload, ValidateSmartSchedulingSlotsResponse } from "../../api/smart-scheduling/smart-scheduling.types";

import { validateSmartSchedulingSlots } from "../../api/smart-scheduling/validate-smart-scheduling-slots";

export function useValidateSmartSchedulingSlots() {
  const { t } = useTranslation();
  const { userToken } = useParams();

  if (!userToken) {
    toast.error({ title: t("User token is required") });
    return;
  }

  return useMutation({
    mutationFn: (payload: SmartSchedulingSlotsPayload) => validateSmartSchedulingSlots(userToken, payload) as Promise<ValidateSmartSchedulingSlotsResponse>,
    onError: (error) => {
      return error;
    },
  });
}
